<style scoped lang="scss" type="text/scss">
    .accommodation-container {
        margin-bottom: -1rem;

        .accommodation-items {
            margin: 1rem 0;

            .accommodation-items-wrap {
                margin: -1rem 0 0 -1rem;
                display: flex;
                flex-wrap: wrap;
            }

            .accommodation-item {
                height: 8rem;
                width: calc(50% - 1rem);
                margin: 1rem 0 0 1rem;
            }
        }
    }

    @media screen and (min-width: 95rem) {
        .accommodation-item {
            width: calc(33.3% - 1rem) !important;
        }
    }
</style>

<template>
    <div class="accommodation-container">
        <block-divider>住宿信息</block-divider>
        <div class="accommodation-items">
            <div class="accommodation-items-wrap">
                <add-block class="accommodation-item" title="住宿信息" reversed @click.native="showEditor"></add-block>

                <accommodation-item class="accommodation-item" v-for="(accommodation, index) in accommodations"
                                    :key="index"
                                    :editable="true" :info="accommodation" :index="index + 1"
                                    @call-edit="showUpdateEditor(accommodation.id, ...arguments)"
                                    @call-remove="remove(accommodation.id, ...arguments)"
                >
                </accommodation-item>
            </div>
        </div>

        <popup :visible.sync="isEditorVisible"
               :is-update="isUpdateMode"
               :id="updateId"
               :deletable="isUpdateMode"
               @need-reload="loadPlayerAccommodations"
        >
        </popup>
    </div>
</template>

<script>
    import BlockDivider from '../../../../../components/divider/block';
    import Placeholder from '../../../../../components/placeholder/index';
    import AccommodationItem from '../../../../sub-components/accommodation-item/index';
    import AddBlock from '../../../../../components/add-block/index';
    import Popup from './popup';
    import {mapState} from 'vuex';

    export default {
        name: '',
        components: {
            BlockDivider,
            Placeholder,
            AccommodationItem,
            AddBlock,
            Popup
        },
        data () {
            return {
                isEditorVisible: false,
                deletable: false,
                isUpdateMode: false,
                updateId: null
            };
        },
        computed: {
            ...mapState('player', {
                currentManagedPlayerId: state => state.currentManagedPlayerId,
                accommodations: state => state.currentManagedPlayerAccommodations

            })
        },
        watch: {
            currentManagedPlayerId: {
                immediate: true,
                handler (currentManagedPlayerId) {
                    if (currentManagedPlayerId === null || currentManagedPlayerId === undefined) return;
                    this.loadPlayerAccommodations();
                }
            }
        },
        methods: {
            loadPlayerAccommodations () {
                return this.$store.dispatch('player/loadAccommodations', {
                    id: this.currentManagedPlayerId
                }).then(response => {
                }).catch(_ => {
                });
            },
            showEditor () {
                this.updateId = null;
                this.isUpdateMode = false;
                this.isEditorVisible = true;
            },
            showUpdateEditor (id, callback) {
                this.updateId = id;
                this.isUpdateMode = true;
                this.isEditorVisible = true;
                callback();
            },
            remove (id, callback) {
                this.$deleteConfirm().then(_ => {
                    this.$normalRequest('player/deleteAccommodation', {id}, '删除成功').then(_ => {
                        this.loadPlayerAccommodations().then(_ => {
                            callback();
                        });
                    }).catch(_ => {
                        callback();
                    });
                }).catch(_ => {
                    callback();
                });
            }
        }
    };
</script>
